import { BaseHttpService } from "./BaseHttpService";
import clientTokenHelper from "./ClientTokenHelper";

export interface IAuth0Error {
  error?: string;
  error_description?: string;
  friendly_message?: string;
  message?: string;
  description?: string;
}

interface ISignupParams {
  username: string;
  email: string;
  password: string;
  birthday: number;
  validation_code: string;
  validation_token: string;
  preferences: string;
  niches: string;
  tags: string;
}

interface ISignupRequestParams {
  client_id: string;
  email: string;
  password: string;
  connection: string;
  username: string;
  given_name?: string;
  family_name?: string;
  nickname?: string;
  name?: string;
  picture?: string;
  user_metadata: {
    birthday: string;
    validation_code: string;
    validation_token: string;
    preferences: string;
    niches: string;
    tags: string;
  };
}

interface ISignupResponse {
  _id: string;
  email_verified: boolean;
  email: string;
  username: string;
  given_name: string;
  family_name: string;
  name: string;
  nickname: string;
  picture: string;
}

interface IResetPasswordParams {
  email: string;
}

interface IResetPasswordRequestParams {
  client_id: string;
  email: string;
  connection: string;
}

interface IResetPasswordResponse {
  message: string;
}

export default class Auth0Service extends BaseHttpService {
  public constructor() {
    super(import.meta.env.REACT_APP_AUTH0_URL);
  }

  public async signup(userParams: ISignupParams): Promise<ISignupResponse> {
    const params: ISignupRequestParams = {
      client_id: import.meta.env.REACT_APP_AUTH0_CLIENT_ID,
      connection: import.meta.env.REACT_APP_AUTH0_CONNECTION,
      email: userParams.email,
      password: userParams.password,
      username: userParams.username,
      nickname: userParams.username,
      name: userParams.username,
      user_metadata: {
        birthday: `${userParams.birthday}`,
        validation_code: userParams.validation_code,
        validation_token: userParams.validation_token,
        preferences: userParams.preferences,
        niches: userParams.niches,
        tags: userParams.tags,
      }
    };

    return await this.post("/dbconnections/signup", params);
  }

  public async resetPassword(userParams: IResetPasswordParams): Promise<IResetPasswordResponse> {
    const params: IResetPasswordRequestParams = {
      client_id: import.meta.env.REACT_APP_AUTH0_CLIENT_ID,
      connection: import.meta.env.REACT_APP_AUTH0_CONNECTION,
      email: userParams.email,
    };

    const message = await this.post("/dbconnections/change_password", params);

    return { message };
  }
}
